import { Form, Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import TextField from "@components/Forms/FormInputs/TextField";

import routes from "@constants/routes";

import userService from "@services/user.service";

import theme from "@theme/index";

const valueSchema = Yup.object().shape({
  confirmPassword: Yup.string()
    .required("Required")
    .oneOf([Yup.ref("password")], "Passwords must match"),
  password: Yup.string()
    .min(8, "Must be at least 8 characters")
    .max(20, "Must be less than 20 characters")
    .required("Required"),
});

function PasswordReset() {
  const { token } = useParams();
  const navigate = useNavigate();

  if (!token) {
    navigate(routes.LOGIN);
    return;
  }

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <LockOutlinedIcon />
      <Typography component="h1" variant="h5">
        Reset Your Password
      </Typography>
      <Formik
        initialValues={{
          confirmPassword: "",
          password: "",
        }}
        onSubmit={(values) => {
          void userService.resetPassword(values.password, token);
        }}
        validationSchema={valueSchema}
      >
        {({ dirty, isSubmitting, isValid }) => (
          <Form style={{ width: "100%" }}>
            <TextField isFullWidth isRequired label="Password" name="password" type="password" />
            <TextField isFullWidth isRequired label="Confirm Password" name="confirmPassword" type="password" />
            <Button
              color="primary"
              disabled={!isValid || !dirty || isSubmitting}
              fullWidth
              sx={{ margin: theme.spacing(1, 0, 2) }}
              type="submit"
              variant="contained"
            >
              {isSubmitting ? <CircularProgress size={20} /> : <>Reset</>}
            </Button>
          </Form>
        )}
      </Formik>
    </Container>
  );
}

export default PasswordReset;
